import useApiQuery from 'shared/hooks/use-api-query';
import {PaymentMethodProps} from '../types';

const usePaymentMethodsByCitySelect = (cityId?: string) => {
  const {data = [], ...rest} = useApiQuery<PaymentMethodProps[]>({
    url: `/payment-methods/cities/${cityId}/all`,
    enabled: !!cityId,
  });

  return {
    ...rest,
    data: data?.map((paymentMethod: PaymentMethodProps) => ({
      label: paymentMethod.name,
      value: paymentMethod.id,
    })),
  };
};

export default usePaymentMethodsByCitySelect;
